// CreateProject.js
import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { supabase } from '../../supabaseClient';
import GoogleMapPicker from './GoogleMapPicker';

export default function CreateProject({ onClose }) {
  const { user } = useContext(AuthContext);
  const [name, setName] = useState('');
  const [lat, setLat] = useState(null);
  const [lon, setLon] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Update location when a user clicks on the map.
  const handleLocationSelect = (position) => {
    setLat(position.lat);
    setLon(position.lng);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Ensure the user has provided a project name and selected a location.
    if (!name.trim() || lat === null || lon === null) {
      setError('Please provide a project name and select a location.');
      return;
    }

    setLoading(true);

    // Convert coordinates into a PostGIS-compatible WKT string (note: longitude comes first).
    const masterGps = `SRID=4326;POINT(${lon} ${lat})`;

    const newProject = {
      name: name.trim(),
      master_gps: masterGps,
      organization_id: user.organization_id || null,
    };

    const { error: insertError } = await supabase
      .from('projects')
      .insert([newProject]);

    if (insertError) {
      setError(insertError.message);
      setLoading(false);
      return;
    }

    setLoading(false);
    onClose(); // Close the modal
    navigate('/projects'); // Optionally navigate to the projects list
  };

  return (
    <div>
      <div className="flex items-center justify-between pb-4 border-b">
        <h2 className="text-2xl font-bold">Create New Project</h2>
        <button onClick={onClose} className="text-gray-600 hover:text-gray-800">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>
      {error && <p className="mt-2 text-red-500">{error}</p>}
      <form onSubmit={handleSubmit} className="mt-4 space-y-4">
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-gray-700">
            Project Name
          </label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
            placeholder="Enter project name"
          />
        </div>
        <div>
          <label className="block text-sm text-gray-500 my-2">
          Click on the map to select the approximate project location.
          </label>
          <GoogleMapPicker onLocationSelect={handleLocationSelect} />
          
        </div>
        <div className="flex justify-end space-x-2">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={loading}
            className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
          >
            {loading ? 'Creating...' : 'Create Project'}
          </button>
        </div>
      </form>
    </div>
  );
}
